import { DEFAULT_REACTION_PRESETS, DEFAULT_SOUNDBITE_PRESETS } from '@flip7/shared';
import type { Toast } from '../hooks/useReactions';

interface ReactionToastsProps {
  toasts: Toast[];
}

export function ReactionToasts({ toasts }: ReactionToastsProps) {
  if (toasts.length === 0) return null;

  return (
    <div className="reaction-toasts">
      {toasts.map(toast => {
        if (toast.kind === 'reaction') {
          const preset = DEFAULT_REACTION_PRESETS[toast.reactionId];
          const icon = toast.icon ?? preset?.icon;
          const label = toast.label ?? preset?.label ?? toast.reactionId;
          return (
            <div key={toast.id} className="reaction-toast">
              <span className="reaction-toast__player">{toast.playerName}</span>
              <span className="reaction-toast__icon">{icon}</span>
              <span className="reaction-toast__label">{label}</span>
            </div>
          );
        }

        if (toast.kind === 'soundbite') {
          const preset = DEFAULT_SOUNDBITE_PRESETS[toast.soundbiteId];
          return (
            <div key={toast.id} className="reaction-toast">
              <span className="reaction-toast__player">{toast.playerName}</span>
              <span className="reaction-toast__icon">{'\uD83D\uDD0A'}</span>
              <span className="reaction-toast__label">{preset?.label ?? toast.soundbiteId}</span>
            </div>
          );
        }

        return (
          <div key={toast.id} className="reaction-toast">
            <span className="reaction-toast__player">{toast.playerName}</span>
            <span className="reaction-toast__icon">{'\uD83D\uDD0A'}</span>
            <span className="reaction-toast__label reaction-toast__label--muted">voice memo</span>
          </div>
        );
      })}
    </div>
  );
}
